import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(() => ({
  box: {
    padding: '.5rem',
    background: 'white',
    borderRadius: '8px',
    border: '1px solid #C4C4C4',
    marginTop: "10px"
  },
  map: {
    height: "300px", 
    width: "100%"
  },
  iconButton: {
    padding: 0
  }
}));

export default styles;